// extracted by mini-css-extract-plugin
export default {"powerUserTag":"PowerUserBadgeStyles_powerUserTag__7444g"};